import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import budgit from "../../../assets/logos/budgit.png";
import blue from "../../../assets/logos/blue.png";
import ogun from "../../../assets/logos/ogun_state.jpg";
import fish from "../../../assets/logos/fish_afrique.png";
import bat from "../../../assets/logos/bat.png";
import seamless from "../../../assets/logos/seamless.png";
import folio from "../../../assets/logos/folio.png";
import coop from "../../../assets/logos/coop.png";
import fishshoal from "../../../assets/logos/fishshoal.jpg";

const Partners = () => {
  return (
    <Box margin={{ xs: "25% 0%", sm: "2% 0%" }} width={"100%"}>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Partners
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "100%" }}
        padding={{ xs: "5% 0%", sm: "2% 0%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
        // data-aos={"fade-down"}
      >
        <Box
          component="img"
          height={{ xs: "13vh", sm: "14vh" }}
          width={{ xs: "45%", sm: "180px" }}
          marginRight={{ xs: "0%", sm: "4%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={blue}
          alt={"blue-echo-foundation"}
        />
        <Box
          component="img"
          height={{ xs: "7vh", sm: "10vh" }}
          width={{ xs: "45%", sm: "250px" }}
          marginRight={{ xs: "0%", sm: "4%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={fishshoal}
          alt={"fish_shoal"}
        />
        <Box
          component="img"
          height={{ xs: "20vh", sm: "20vh" }}
          width={{ xs: "47%", sm: "160px" }}
          marginRight={{ xs: "0%", sm: "4%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={bat}
          alt={"BAT-foundation"}
        />
        <Box
          component="img"
          height={{ xs: "16vh", sm: "21vh" }}
          width={{ xs: "42%", sm: "180px" }}
          marginRight={{ xs: "0%", sm: "4%" }}
          marginBottom={{ xs: "2%", sm: "0%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={ogun}
          alt={"ogun-state-government"}
        />
        <Box
          component="img"
          height={{ xs: "7vh", sm: "11vh" }}
          width={{ xs: "42%", sm: "200px" }}
          marginRight={{ xs: "4%", sm: "4%" }}
          marginTop={{ xs: "8%", sm: "0%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={budgit}
          alt={"budgit_logo"}
        />
        <Box
          component="img"
          height={{ xs: "7vh", sm: "11vh" }}
          width={{ xs: "42%", sm: "230px" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "8%", sm: "0%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={fish}
          alt={"fish_afrique"}
        />
        <Box
          component="img"
          height={{ xs: "4vh", sm: "7vh" }}
          width={{ xs: "45%", sm: "250px" }}
          marginTop={{ xs: "8%", sm: "0%" }}
          marginLeft={{ xs: "0%", sm: "1%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={seamless}
          alt={"seamlessHR"}
        />
        <Box
          component="img"
          height={{ xs: "6vh", sm: "11vh" }}
          width={{ xs: "45%", sm: "250px" }}
          marginTop={{ xs: "8%", sm: "0%" }}
          marginLeft={{ xs: "0%", sm: "1%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={coop}
          alt={"coop_exchange"}
        />
        <Box
          component="img"
          height={{ xs: "20vh", sm: "20vh" }}
          width={{ xs: "45%", sm: "180px" }}
          marginTop={{ xs: "4%", sm: "0%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={folio}
          alt={"Folio_Design"}
        />
      </Box>
    </Box>
  );
};

export default Partners;
